import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";

import { previewBannerText, previewReadOnlyText } from "../lib/preview-as";
import { Button } from "./ui/Button";

type PreviewBannerProps = {
  name: string;
  /** The API sentence, when the preview request failed. */
  message?: string | null;
  onExit: () => void;
  className?: string;
};

export const PreviewBanner: React.FC<PreviewBannerProps> = ({
  name,
  message,
  onExit,
  className = "",
}) => (
  <div
    data-testid="preview-banner"
    role="status"
    className={`flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-od-border bg-od-surface-2 px-3 py-2 ${className}`}
  >
    <VisibilityIcon
      sx={{ fontSize: 16 }}
      className="shrink-0 text-od-muted"
      aria-hidden="true"
    />
    <p className="m-0 min-w-0 flex-1 text-sm text-od-text">
      {message ? (
        message
      ) : (
        <>
          {previewBannerText(name)} {previewReadOnlyText()}
        </>
      )}
    </p>
    <Button variant="secondary" size="sm" onClick={onExit}>
      Exit preview
    </Button>
  </div>
);

export default PreviewBanner;
